import { Box, Grid, Typography } from '@mui/material';
import { Product } from 'types/graphql';

import SummaryOrderItems from './OrderItems';

interface SummaryOrderListsProps {
    orders: {
        primaryProducts?: Product[]
        secondaryProducts?: Product[]
    }
    currency: string
    contractTerm: number
}

const SummaryOrderLists = ({
    orders,
    currency,
    contractTerm,
}: SummaryOrderListsProps) => {
    return (
        <>
            <Typography fontSize="16px" color="#F18F34" marginBottom="8px">
                Primary Order
            </Typography>
            <Box
                display="flex"
                flexDirection="column"
                sx={{
                    '& .MuiGrid-item': {
                        padding: '8px 16px 16px 8px',
                    },
                }}
            >
                <Grid container spacing={2} width="100%">
                    <Grid item xs={3} />
                    <Grid
                        container
                        xs={8}
                        width="100%"
                        sx={{
                            borderBottom: '1px solid #575757',
                        }}
                    >
                        <Grid item xs={3}>
                            <Typography
                                fontSize="20px"
                                fontWeight={600}
                                color="#1D1D1B"
                                textAlign="center"
                            >
                                Setup
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography
                                fontSize="20px"
                                fontWeight={600}
                                color="#1D1D1B"
                                textAlign="center"
                            >
                                QTY
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography
                                fontSize="20px"
                                fontWeight={600}
                                color="#1D1D1B"
                                textAlign="center"
                            >
                                Monthly Rental
                            </Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography
                                fontSize="20px"
                                fontWeight={600}
                                color="#1D1D1B"
                                textAlign="center"
                            >
                                Total
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={1} />
                </Grid>
                <Box
                    sx={{
                        my: '8px',
                    }}
                />{' '}
                <Grid
                    container
                    spacing={2}
                    rowGap={1}
                    alignItems={'center'}
                    width="100%"
                    sx={{
                        '& .MuiGrid-item': {
                            padding: '12px 12px 12px 12px',
                        },
                    }}
                >
                    {orders?.primaryProducts?.length === 0 || !orders?.primaryProducts ? (
                        <Typography fontSize="14px" color="#575757" marginBottom="8px">
                            N/A
                        </Typography>
                    ) : (
                        <>
                            {orders?.primaryProducts.map((order) => {
                                return (
                                    <SummaryOrderItems
                                        order={order}
                                        contractTerm={contractTerm}
                                        currency={currency}
                                        key={order.id}
                                    />
                                );
                            })}
                        </>
                    )}
                    <Grid item width={'100%'}>
                        <Typography fontSize="16px" color="#F18F34" marginBottom="8px">
                            Secondary Order
                        </Typography>
                    </Grid>
                    {orders?.secondaryProducts?.length === 0 ||
          !orders?.secondaryProducts ? (
                            <Typography
                                fontSize="14px"
                                color="#575757"
                                marginBottom="8px"
                                px={2}
                            >
                                N/A
                            </Typography>
                        ) : (
                            <>
                                {orders?.secondaryProducts.map((order) => {return (
                                    <SummaryOrderItems
                                        order={order}
                                        contractTerm={contractTerm}
                                        currency={currency}
                                        key={order.id}
                                    />
                                );})}
                            </>
                        )}
                </Grid>
            </Box>
        </>
    );
};
export default SummaryOrderLists;
